import React from "react";
import { Helmet } from "react-helmet";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";

const AgentSeoHead = ({ agent, missing }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  if (isGitchaDefaultWebsite !== true) return null;
  const name = [agent?.FirstName, agent?.LastName].filter(Boolean).join(" ");
  const title = name ? `${name} | Real estate agent | Gitcha` : "Real estate agent | Gitcha";
  const description = name
    ? `Explore ${name}'s public buyer Want-Listings${agent.Company ? ` with ${agent.Company}` : ""} and connect on Gitcha.`
    : "Explore real estate agents and their public buyer Want-Listings on Gitcha.";
  const canonical = typeof window === "undefined" ? "" : `${window.location.origin || ""}${window.location.pathname || ""}`;
  const schema = name && !missing ? {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    url: canonical,
    name: title,
    mainEntity: {
      "@type": "Person",
      name,
      url: canonical,
      ...(agent.Company ? { worksFor: { "@type": "Organization", name: agent.Company } } : {}),
    },
  } : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {missing === "notFound" ? <meta name="robots" content="noindex" /> : null}
      {name && !missing ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {schema ? <script type="application/ld+json">{JSON.stringify(schema).replace(/</g, "\\u003c")}</script> : null}
    </Helmet>
  );
};

export default AgentSeoHead;
